import { useEffect, useState } from "react";
import { getToken } from "../../../services/authService";

// Las alarmas solo aplican a Cazadores (han participado alguna vez con rol
// CAZADOR en una cacería) y a Titulares de Arma (tipoPersona === "TITULAR").
export function useNotificacionesData() {
    const [loading, setLoading] = useState(true);
    const [personas, setPersonas] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        let mounted = true;

        (async () => {
            setLoading(true);
            setError(null);
            try {
                const token = getToken();
                const headers = { Authorization: `Bearer ${token}` };
                const [personasRes, cazadoresRes] = await Promise.all([
                    fetch(`${process.env.REACT_APP_API_URL}/api/personas/all`, { headers }),
                    fetch(`${process.env.REACT_APP_API_URL}/api/personas/cazadores-ids`, { headers }),
                ]);
                if (!personasRes.ok) throw new Error(await personasRes.text());
                if (!cazadoresRes.ok) throw new Error(await cazadoresRes.text());

                const todas = await personasRes.json();
                const cazadorIds = new Set(await cazadoresRes.json());

                const conAlarma = (Array.isArray(todas) ? todas : []).filter(
                    (p) => p?.tipoPersona === "TITULAR" || cazadorIds.has(p?.id)
                );

                if (mounted) setPersonas(conAlarma);
            } catch (e) {
                if (mounted) setError(e?.message || "Error cargando personas");
            } finally {
                if (mounted) setLoading(false);
            }
        })();

        return () => {
            mounted = false;
        };
    }, []);

    return { loading, personas, error };
}
